import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import TLink from '../../components/TLink'
import { translate } from '../../utils/useful'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'

class LoginPasswordStep extends React.Component {
    state = {
        errors: {},
        formHeaders: [{ key: 'password', type: 'PasswordInput', information: { placeholder: '{{lang}}yourPassword', autoFocus: true, required: true } }]
    }


    componentDidMount() {
        document.addEventListener("keydown", this._handleKeyDown);
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.userCheckPassword()
        }
    }



    userCheckPassword = () => {
        this.setState({ isLoading: true, errors: {} })
        let data = this.form.getForm()
        this.props.setData(data, () => {
            this.props.userCheckPassword((result, err) => {
                if (err) { this.setState({ errors: err }) }
                this.setState({ isLoading: false })
            })
        })
    }




    render() {
        return (

            <div className="flexcc flex-column pt-5">
                <div className='w-100 px-5'>
                    {this.props.settings.mode == 'forgotPassword' ? (
                        <>
                            <div className='d-flex mt-3 mb-4 '>
                                <h2 className=" text-title1 font-size-24 weight-500 mx-2" style={{}}>{translate('Insert Your New Password')}</h2>
                            </div>
                            {/* <p className=" text-title1 mb-4 mld-5 pld-5 text-normal text-bold" style={{}}>{translate('to log in')}</p> */}
                        </>
                    ) : (
                        <>
                            <div className='d-flex mt-3'>
                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => this.props.lastStage()} fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="#33486e" className='cursor-pointer' style={{ width: 25 }}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                </svg>

                                <h2 className=" text-title1 font-size-24 weight-500 mx-2" style={{}}>{translate('Insert Your Password')}</h2>

                            </div>
                            <p className=" text-title1 mb-4 mld-5 pld-5 text-normal text-bold" style={{}}>{translate('to log in')}</p>
                        </>
                    )}
                    <div className="w-100" style={{ maxWidth: 400 }}>

                        <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'phone-input'} nopadding={true} />
                        <div className='' >

                            <div className="">


                                {/* <LoaderButton
                                    onClick={() => this.userCheckPassword()}
                                    isLoading={this.state.isLoading}
                                    text={translate("Submit")}
                                    backgroundImage='linear-gradient(45deg, #30A1B8 0%, #5598DE 40%, #8E81F4  70%, #F45495  90%, #EE4358  100%)'
                                    shadow="0px 0px 14px -7px #007aff;"
                                    icon={'/assets/icons/angle-right-white2.svg'}
                                    className={'button-interactive-1'}
                                    language={this.props.language}
                                /> */}
                                <div className=''>
                                    <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={this.props.textColor} title={'Submit'} onClick={this.userCheckPassword} isLoading={this.state.isLoading} />

                                </div>
                                {this.props.settings.mode == 'login' && (
                                <div className="mt-2">
                                    <button onClick={() => { this.props.postForgotPassword() }}>
                                        <p style={{ cursor: 'pointer', fontSize: 13, color: "gray", border: 'none', backgroundColor: 'transparent', outline: 'none', marginBottom: 10 }} >{translate('Forgot your password?')}</p>
                                    </button>
                                    {/* <TLink pathname={'/forgotpassword'} style={{ cursor: 'pointer', fontSize: 13, color: "gray", border: 'none', backgroundColor: 'transparent', outline: 'none', marginBottom: 10 }} >{translate('Forgot your password?')}</TLink> */}
                                </div>
                                )}


                            </div>

                            {/* <div className="w-100 mt-2">
                                <button className="mb-3" onClick={() => this.props.lastStage()} style={{ fontSize: 13, }}>{translate('back-one-stage')}</button>

                            </div> */}
                        </div>
                    </div>
                </div>
            </div >

        )
    }
}

export default LoginPasswordStep;